import { render } from "./FrequencyCapping.vue?vue&type=template&id=6db41d12"
import script from "./FrequencyCapping.vue?vue&type=script&lang=js"
export * from "./FrequencyCapping.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__